module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/color/color.component.html
// module id = ./src/app/productos/color/color.component.html
// module chunks = main